<!-- 投诉分类 -->
<template>
    <div class="mine-function">
        <div class="mine-function-header flex align-center">
            <img class="mine-function-title-image" src="@/assets/images/suggestion/sort.png" alt="" />
            <p class="mine-function-title">投诉分类</p>
        </div>
        <div class="mine-function-wrap flex justify-between align-center">
            <div class="mine-function-item flex flex-column justify-center align-center" v-for="(item, index) in dataList" :key="index" @click="handleItem(item)">
                <img :src="item.icon" alt="" />
                <p>{{ item.name }}</p>
            </div>
        </div>
        <Dialog :show.sync="showDialog" @hideDialog="hideDialog" @handleLeftBtn="showDialog = false" @handleConfirm="handleConfirm" leftBtnText="我知道了" rightBtnText="去认证" content="如需查看车辆账单，请先认证车辆！" />
    </div>
</template>

<script>
import Dialog from "@/components/base/dialog/dialog.vue";
export default {
    name: "SuggestionSort",
    components: {
        Dialog,
    },
    data() {
        return {
            showDialog: false,
            userInfo: {
                isVerify: 1, //0:未认证,1：已认证
            },
            dataList: [
                {
                    icon: require("@/assets/images/suggestion/orderAppeal.png"),
                    name: "订单申诉",
                    route: "/suggestion/orderAppeal",
                },
                {
                    icon: require("@/assets/images/suggestion/orderSuggestion.png"),
                    name: "投诉建议",
                    route: "/suggestion/complaintSuggestion",
                },
                {
                    icon: require("@/assets/images/suggestion/orderHistory.png"),
                    name: "申诉记录",
                    route: "/suggestion/complainHtistory",
                },
            ],
        };
    },

    methods: {
        handleItem(item) {
            if (this.userInfo.isVerify == 0) {
                this.showDialog = true;
            } else {
                this.$router.push(item.route);
            }
        },
        hideDialog(data) {
            this.showDialog = data;
        },
        // 车辆未认证去认证
        handleConfirm() {
            this.$router.push("/mycar/vehicleCertification");
        },
    },
};
</script>

<style lang="less" scoped>
.mine-function {
    width: 100%;
    height: 256px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    .mine-function-header {
        padding: 24px 32px;
        .mine-function-title-image {
            width: 32px;
            height: 32px;
            margin-right: 16px;
        }
        .mine-function-title {
            color: #666666;
            font-size: 26px;
        }
    }
    .mine-function-wrap {
        flex: 1;
        .mine-function-item {
            flex: 1;
            height: 100%;
            img {
                width: 80px;
                height: 80px;
                margin-bottom: 16px;
            }
            p {
                color: #999;
                font-size: 26px;
            }
        }
    }
}
</style>
